<template lang="pug">
    .editable-input.control(:class="{ 'is-edit': editState, 'has-error': error.length }")
        button.button.is-primary(v-show="editState" @click="save")
            span.icon
                i.fas.fa-check
        button.button(v-show="!editState" @click="edit")
            span.icon
                i.fas.fa-pencil-alt
        template(v-if="editState")
            .select.is-fullwidth(v-if="isSelect")
                select(:value="value" @change="val=$event.target.value")
                    option(v-for="item of select" :value="item._id") {{ item.name }}
            input.input(
                v-else
                ref="input"
                step="2"
                :type="type"
                :value="value"
                @input="val=$event.target.value"
                @focus="error=''")
        template(v-else)
            a.input.text-overflow(v-if="isLink" :href="href" target="_blank") {{ value }}
            span.input.text-overflow(v-else) {{ getValue(value) }}
        .button.is-danger(v-show="error.length && editState" :title="error")
            span.icon
                i.fas.fa-times
</template>

<script>
export default {
  name: "EditInput",
  props: {
    isTime: {
      type: Boolean
    },
    isLink: {
      type: Boolean
    },
    isSelect: {
      type: Boolean
    },
    select: {
      type: Array
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    validation: {
      type: Function,
      default: async () => {
        return {
          status: true,
          message: "Validation error"
        };
      }
    }
  },
  data: () => ({
    editState: false,
    error: "",
    val: ""
  }),
  computed: {
    href() {
      return this.type === "email" ? `mailto:${this.value}` : this.value;
    }
  },
  methods: {
    edit() {
      this.editState = true;

      setTimeout(() => {
        if (this.$refs.input) this.$refs.input.focus();
      }, 0);
    },
    save() {
      this.validation().then(res => {
        if (res.status) {
          this.$emit("input", this.val);
          this.editState = false;
        } else {
          this.error = res.message;
        }
      });
    },
    getValue(val) {
      if (this.isSelect) {
        const data = this.select || [];
        const item = data.find(i => i._id === val);
        if (item) return item.name;
        else return this.select.length ? this.select[0].name : "None";
      } else {
        return this.type === "password"
          ? new Array(val.length).fill("*").join("")
          : val;
      }
    }
  },
  mounted() {
    this.val = this.value;
  }
};
</script>

<style lang="scss" scoped>
.editable-input {
  position: relative;
  width: 100%;
  display: flex;
  padding: 0.15rem;
  border-radius: 2rem;
  background-color: #ddd;
  overflow: hidden;

  &.is-edit {
    background-color: $defaultColor;
    &.has-error {
      width: calc(100% - 2.5rem);
    }
  }

  .button {
    background-color: #ccc;
    border-radius: 50%;

    &.is-danger {
      position: absolute;
      right: -2.5rem;
      cursor: help;
    }
  }
  .input {
    display: block;
    background-color: transparent;
    box-shadow: none;
    border: none;
    color: #666666;
    text-align: left;
  }

  a.input {
    text-decoration: underline;
  }

  .select {
    select {
      border: none;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
